import { render } from "./InvoiceGenerator.vue?vue&type=template&id=36d690c8"
import script from "./InvoiceGenerator.vue?vue&type=script&lang=js"
export * from "./InvoiceGenerator.vue?vue&type=script&lang=js"

import "./InvoiceGenerator.vue?vue&type=style&index=0&id=36d690c8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__